<template>
  <div class="zbz-box">
	<div class="zbz-box-container">
		<div class="zbz-bg-layer" :style="backgroundStyle"></div>
		<div class="zbz-bg-overlay"></div>
		<!-- 左侧 -->
		<div class="zbz-left" v-if="isHost || showViewerLeft">
		  <!-- 主播：直播间设置 -->
		  <div class="zbz-zhiboshezhi" v-if="isHost">
		  	<div class="zbz-left-title">{{$t('all.zhibojiansetting')}}</div>
		  	<div class="zbz-settings">
				<div class="zbz-setting-item" @click="toggleSound">
				  <img class="zbz-setting-icon" src="../../../assets/image/zbsz_kaiqishengyin_28@2x.png" alt="" />
				  <span class="zbz-setting-text">{{soundOn ? $t('all.kaiqishengyin') : $t('all.guanbishengyin')}}</span>
				</div>
				<div class="zbz-setting-item" @click="toggleDanmu">
				  <img class="zbz-setting-icon" v-if="danmuOn" src="../../../assets/image/zbsz_kqdanmu_28@2x.png" alt="" />
				  <img class="zbz-setting-icon" v-if="!danmuOn" src="../../../assets/image/zbsz_guanbidanmu_28@2x.png" alt="" />
				  <span class="zbz-setting-text">{{danmuOn ? $t('all.guanbidanmu') : $t('all.kaiqidanmu')}}</span>
				</div>
				<div class="zbz-setting-item" @click="toggleMic">
				  <img class="zbz-setting-icon" v-if="micOn" src="../../../assets/image/zbsz_kqmaikefeng_28@2x.png" alt="" />
				  <img class="zbz-setting-icon" v-else src="../../../assets/image/zbsz_gbmaikefeng_28@2x.png" alt="" />
				  <span class="zbz-setting-text">{{micOn ? $t('all.kaiqimaikefeng') : $t('all.guanbimaikefeng')}}</span>
				</div>
				<div class="zbz-setting-item" @click="handleShowNotice">
				  <img class="zbz-setting-icon" src="../../../assets/image/zbsz_gonggao_28@2x.png" alt="" />
				  <span class="zbz-setting-text">{{$t('all.gonggao')}}</span>
				</div>
				<div class="zbz-setting-item" @click="handleShare">
				  <img class="zbz-setting-icon" src="../../../assets/image/zbsz_fxlj_28@2x.png" alt="" />
				  <span class="zbz-setting-text">{{$t('all.fenxianglianjie')}}</span>
				</div>
				<div class="zbz-setting-item" @click="handleCreateHelpLive">
				  <img class="zbz-setting-icon" src="../../../assets/image/zbsz_kqxtzb_28@2x.png" alt="" />
				  <span class="zbz-setting-text">{{$t('all.xietongzhibo')}}</span>
				</div>
		  	</div>
		  </div>
		  <!-- 观众：直播商品标题 -->
		  <div class="zbz-viewer-goods-title" v-if="!isHost">
			<span class="zbz-goods-title">{{$t('all.zhiboshangpin')}}</span>
			<img class="zbz-viewer-goods-title-img" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" @click="showViewerLeft = false"/>
		  </div>
		  <div class="zbz-zhiboshangpin">
		  	<!-- 主播：商品+库存加减 -->
		  	<div class="zbz-goods-header" v-if="isHost">
				<span class="zbz-goods-title">{{$t('all.zhiboshangpin')}}</span>
				<img class="zbz-goods-setting" src="../../../assets/image/shangpinshezhi@2x.png" alt="" />
		  	</div>
		  	<div class="zbz-goods-list">
				<!-- 主播商品 -->
				<div class="zbz-goods-item" v-if="isHost" v-for="(item, index) in goodsList" :key="'h'+index">
				  <img class="zbz-goods-img" :src="item.mediasList[0].uri" alt="" />
				  <div class="zbz-goods-item-content">
				  	<div class="zbz-goods-info">
						<span class="zbz-goods-name">{{item.goodsName}}</span>
						<span class="zbz-goods-stock">{{$t('all.shangchengkucun')}}：{{item.totalStock}}</span>
				  	</div>
					<div class="zbz-viewer-goods-price">
						<span class="zbz-viewer-price-text">USDN {{item.price}}</span>
						<div class="zbz-viewer-buy-btn" @click="setGoodsExplain(item)">{{item.isExplain===1?$t('all.jiangjiezhong'):$t('all.jiangjie')}}</div>
					</div>
				  	<!-- <div class="zbz-goods-counter">
						<img class="zbz-goods-counter-btn" @click="decreaseStock(item)" src="../../../assets/image/shuliang_jian@2x.png" alt="" />
						<span class="zbz-goods-counter-value">{{item.liveStock}}</span>
						<img class="zbz-goods-counter-btn" @click="increaseStock(item)" src="../../../assets/image/shuliang_jia@2x.png" alt="" />
				  	</div> -->
				  </div>
				</div>
				<!-- 观众商品 -->
				<div class="zbz-goods-item zbz-viewer-goods-item" v-if="!isHost" v-for="(item, index) in goodsList" :key="'v'+index" @click="handleViewGoodsDetail(item)">
				  <img class="zbz-goods-img" :src="item.mediasList[0].uri" alt="" />
				  <div class="zbz-goods-item-content">
				  	<div class="zbz-goods-info">
						<span class="zbz-goods-name">{{item.goodsName}}</span>
						<span class="zbz-goods-stock">{{$t('all.shangchengkucun')}}：{{item.totalStock}}</span>
				  	</div>
				  	<div class="zbz-viewer-goods-price">
						<span class="zbz-viewer-price-text">USDN {{item.price}}</span>
						<div class="zbz-viewer-buy-btn" @click.stop="handleBuyGoods(item)" v-if="item.totalStock>0">{{$t('all.goumai')}}</div>
						<div class="zbz-viewer-buy-btn1" v-else>{{$t('all.yishouqing')}}</div>
				  	</div>
				  </div>
				</div>
				<kong v-if="goodsList && goodsList.length == 0" class="kong"></kong>
		  	</div>
		  </div>
		</div>

		<!-- 中间：视频画面 + 控制条 -->
		<div class="zbz-center">
		  <div class="zbz-video-area">
			<div class="zbz-video-wrap">
			  <tengxunyunzb ref="txyzb" v-if="isHost && data && data.mainScreenHelpId == 0" :room-data="data"/>
			  <tengxunyun ref="txy" v-if="!isHost && data && data.mainScreenHelpId == 0"/>
			  <mainscreenplayer 
				v-if="data && data.mainScreenHelpId > 0" 
				:main-screen-data="mainScreenUser" 
				:is-self="isSelfMainScreen" 
				:self-user-id="currentUserId" 
			  />
			</div>
			<!-- 协同直播小窗列表 -->
			<xietongzhibo @select="handleColiveSelect" @joinsuccess="handleJoinSuccess" ref="xietongzhibo" :is-host="isHost" :room-data="data" v-if="data"/>
			
			<!-- 商品购买弹框 -->
			<div class="zbz-video-product-popup" :class="{ 'zbz-video-product-popup-show': showProductPopup && productPopupData && !isHost}">
			<!-- <div class="zbz-video-product-popup" :class="{ 'zbz-video-product-popup-show': showProductPopup && productPopupData }"> -->
				<div class="zbz-video-product-img" >
					<img :src="productPopupData && productPopupData.mediasList && productPopupData.mediasList[0] ? productPopupData.mediasList[0].uri : ''" alt="" />
				</div>
				<div class="zbz-video-product-info">
					<span class="zbz-video-product-name">{{productPopupData && productPopupData.goodsName ? productPopupData.goodsName : ''}}</span>
					<span class="zbz-video-product-price">{{productPopupData?productPopupData.price:0}}</span>
				</div>
				<div class="zbz-video-product-btn" @click="handleProductClick">{{$t('all.lijijiagou')}}</div>
				<img class="zbz-video-product-gb" src="../../../assets/image/tanchuang_x@2x.png" alt="" @click="showProductPopup = false"/>
			</div>
		  </div>
		  <!-- 主播底部控制条 -->
		  <div class="zbz-video-bottom" v-if="isHost">
			<div class="zbz-volume">
			  <img class="zbz-volume-icon" v-if="volume > 0" src="../../../assets/image/zbsz_kqmaikefeng_28@2x.png" alt="" @click="setVolume(0)" />
			  <img class="zbz-volume-icon" v-else src="../../../assets/image/zbsz_gbmaikefeng_28@2x.png" alt="" @click="setVolume(100)" />
			  <input type="range" class="zbz-volume-slider" v-model="volume" min="0" max="100" @input="handleVolumeChange" />
			  <span class="zbz-volume-text">{{volume}}%</span>
			</div>
			<!-- <div class="zbz-live-info">
			  <span class="zbz-live-time">{{$t('all.yizhibo')}}：{{liveTimeText}}</span>
			</div> -->
			<div class="zbz-end-btn" @click="handleEndLive">{{$t('all.jieshizhibo')}}</div>
		  </div>
		  <!-- 观众底部操作栏 -->
		  <div class="zbz-viewer-bottom" v-if="!isHost">
			<div v-if="isJoinedHelpLive" class="zbz-viewer-bottom-item" @click="toggleViewerMic">
			  <img v-if="viewerMicOn" class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_kqmaikefeng_28@2x.png" alt="" />
			  <img v-if="!viewerMicOn" class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_gbmaikefeng_28@2x.png" alt="" />
			  <span>{{$t('all.maikefeng')}}</span>
			</div>
			<div v-if="isJoinedHelpLive" class="zbz-viewer-bottom-item" @click="toggleViewerCamera">
			  <img v-if="viewerCameraOn" class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_shipin_k_24@2x.png" alt="" />
			  <img v-if="!viewerCameraOn" class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_shipin_g_24@2x.png" alt="" />
			  <span>{{$t('all.shipin')}}</span>
			</div>
			<div class="zbz-viewer-bottom-item" @click="handleViewerSound">
			  <img v-if="soundOn" class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_kaiqishengyin_28@2x.png" alt="" />
			  <img v-if="!soundOn" class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_guanbishengyin_28@2x.png" alt="" />
			  <span>{{soundOn ? $t('all.guanbishengyin') : $t('all.kaiqishengyin')}}</span>
			</div>
			<div class="zbz-viewer-bottom-item" @click="toggleDanmu">
			  <img class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_kqdanmu_28@2x.png" alt="" />
			  <span>{{danmuOn ? $t('all.guanbidanmu') : $t('all.kaiqidanmu')}}</span>
			</div>
			<div class="zbz-viewer-bottom-item" @click="handleShare">
			  <img class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_fxlj_28@2x.png" alt="" />
			  <span>{{$t('all.fenxianglianjie')}}</span>
			</div>
			<div class="zbz-viewer-bottom-item" @click="handleShowNotice">
			  <img class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_gonggao_28@2x.png" alt="" />
			  <span>{{$t('all.chakangg')}}</span>
			</div>
			<div class="zbz-viewer-bottom-item" @click="handleShowGoods">
			  <img class="zbz-viewer-bottom-icon" src="../../../assets/image/shangpin_24@2x.png" alt="" />
			  <span>{{$t('all.zhiboshangpin')}}</span>
			</div>
			<div class="zbz-viewer-bottom-item" @click="handleHelpLiveToggle">
			  <img class="zbz-viewer-bottom-icon" src="../../../assets/image/zbsz_kqxtzb_28@2x.png" alt="" />
			  <span>{{isJoinedHelpLive ? $t('all.tuichuxietongzhibo') : $t('all.jiaruxietongzhibo')}}</span>
			</div>
			<div class="zbz-viewer-reward-btn" @click="handleReward">
			  <img class="zbz-viewer-bottom-icon" src="../../../assets/image/dashang_26@2x.png" alt="" />
			  <span>{{$t('all.dashang')}}</span>
			</div>
		  </div>
		</div>

		<!-- 右侧：在线观众 + 弹幕 -->
		<div class="zbz-right">
		  <div class="zbz-online">
			<div class="zbz-online-title">
				<img class="zbz-online-icon" src="../../../assets/image/zhibojian_zaixianguanzhong@2x.png" alt="" />
				<span class="zbz-online-text">{{$t('all.zaixianguanzhong')}}：{{onlineCount}}</span>
			</div>
			<div class="zbz-online-list">
				<div class="zbz-online-item" v-for="(item, index) in onlineUserList" :key="index" @click.stop="handleShowOnlineFj(item,index)">
					<span class="zbz-online-item-sort">{{index + 1}}</span>
					<img class="zbz-online-item-img" :src="item.headPortrait" alt="" />
					<span class="zbz-online-item-name">{{item.nickName}}</span>
					<div class="zbz-chat-item-fj" v-if="isHost && showOnlineFj && onlineIndex == index">
						<div class="zbz-chat-item-fj-item" @click.stop="handleBannedUserById()">
							<span>{{onlineUserInfo.isBannedToPost===0? $t('all.yongjiujinyan'):$t('all.jiechuejinyan')}}</span>
							<img class="zbz-chat-xiaolapa" src="../../../assets/image/xiayibu_10@2x.png" alt=""/>
						</div>
						<div class="zbz-chat-item-fj-item" @click.stop="handleKickUserById(item.userId)">
							<span>{{$t('all.tichubenchang')}}</span>
							<img class="zbz-chat-xiaolapa" src="../../../assets/image/xiayibu_10@2x.png" alt=""/>
						</div>
					</div>
				</div>
				<div class="zbz-online-empty" v-if="onlineUserList.length === 0">
					<span>{{$t('all.zanwuzaixianguanzhong')}}</span>
				</div>
			</div>
		  </div>
		  <div class="zbz-dashang">
		  	<div class="zbz-dashang-box" ref="rewardContainer">
				<div class="zbz-reward-item" v-for="(item, index) in rewardList" :key="index">
					<img class="zbz-reward-avatar" :src="item.sendUserInfo.headPortrait" alt="">
					<span class="zbz-reward-name">{{item.sendUserInfo.nickName}}</span>
					<span class="zbz-reward-text">{{$t('all.dashang')}}</span>
					<span class="zbz-reward-amount">{{item.amount}}</span>
					<span class="zbz-reward-unit">{{item.unitText}}</span>
				</div>
				<!-- <div class="zbz-dashang-box-kong" v-if="rewardList.length == 0">{{$t('all.zhanshidashangxinxi')}}</div> -->
			</div>
		  </div>
		  <!-- 弹幕列表 -->
		  <div class="zbz-chat-list" ref="chatContainer">
			<div class="zbz-chat-item" v-for="(msg, index) in msgList" :key="index" v-if="danmuOn">
			  <div class="zbz-chat-item-box">
				<div class="zbz-chat-content-wrapper" @click.stop="handleShowModelFj(msg,index)">
				  <span class="zbz-chat-nickname" v-if="msg.sendUserInfo">{{msg.sendUserInfo.nickName}}：</span>
				  <span class="zbz-chat-text">
					<template v-if="msg.type == -1">
					  <img class="zbz-chat-xiaolapa" src="../../../assets/image/xlp.png" alt=""/>
					  <span class="zbz-chat-text-msg">{{msg.title}}</span>
					</template>
					<template v-if="!msg.sendUserInfo && !msg.type">
					  <span class="zbz-chat-text-system">{{msg.title}}</span>
					</template>
					<template v-if="msg.type == 3">
					  <span class="zbz-chat-text-msg">{{msg.title}}</span>
					</template>
					<template v-if="msg.type == 1">
					  <span class="zbz-chat-text-join">{{msg.title}}</span>
					</template>
					<template v-if="msg.type == 12">
					  <span class="zbz-chat-text-msg">{{$t('all.songgei')}}{{msg.toUserInfo.nickName}}{{msg.giftInfo.content}}</span>
					  <img class="zbz-chat-gift-img" :src="msg.giftInfo.imgUrl" alt="" />
					  <span class="zbz-chat-text-msg">×{{msg.num}}</span>
					</template>
				  </span>
				</div>
			  </div>
			  <div class="zbz-chat-item-fj" v-if="isHost && showModelFj && msgIndex == index">
			  	<div class="zbz-chat-item-fj-item" @click.stop="handleBannedUser(msg)">
			  		<span>{{sendUserInfo.isBannedToPost===0? $t('all.yongjiujinyan'):$t('all.jiechuejinyan')}}</span>
			  		<img class="zbz-chat-xiaolapa" src="../../../assets/image/xiayibu_10@2x.png" alt=""/>
			  	</div>
			  	<div class="zbz-chat-item-fj-item" @click.stop="handleKickUser(msg)">
			  		<span>{{$t('all.tichubenchang')}}</span>
			  		<img class="zbz-chat-xiaolapa" src="../../../assets/image/xiayibu_10@2x.png" alt=""/>
			  	</div>
			  </div>
			</div>
			
		  </div>
		  <!-- 快捷短语 -->
		  <div class="zbz-quick-bar">
			<div class="zbz-quick-tags" ref="quickTags" v-if="kjdyList.length > 0" @mousedown="startDragScroll" @mousemove="doDragScroll" @mouseup="stopDragScroll" @mouseleave="stopDragScroll">
			  <div class="zbz-quick-item" v-for="(item, index) in kjdyList" :key="index" @click="handleSendKjdy(item.content)">{{item.content}}</div>
			  <img class="zbz-quick-close" src="../../../assets/image/x_22_1@2x.png" alt="" @click="showKjdyTags = false" v-if="showKjdyTags"/>
			</div>
			<img class="zbz-quick-manage-icon" src="../../../assets/image/zbsz_kuaijiefayan_28@2x.png" alt="" @click="showKjdyModal = true" v-if="isHost"/>
		  </div>
		  <!-- 发送消息 -->
		  <div class="zbz-send">
			<textarea class="zbz-send-input" v-model="chatContent" :placeholder="$t('all.shuodianshenmene')" @keydown.enter.prevent="handleSend" rows="1" ref="chatInput" @input="autoResize"></textarea>
		  </div>
		  <!-- 快捷短语管理弹框 -->
		  <div class="zbz-kjdy-modal" v-if="showKjdyModal">
			<div class="zbz-kjdy-header">
			  <img class="zbz-kjdy-add" src="../../../assets/image/tianjia_20@2x.png" alt="" @click="showKjdyAdd = true"/>
			  <span class="zbz-kjdy-title">{{$t('all.kuaijieduanyu')}}</span>
			  <img class="zbz-kjdy-close" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" @click="showKjdyModal = false"/>
			</div>
			<div class="zbz-kjdy-list">
			  <div class="zbz-kjdy-item" v-for="(item, index) in kjdyList" :key="index">
				<span class="zbz-kjdy-item-text">{{item.content}}</span>
				<img class="zbz-kjdy-item-del" src="../../../assets/image/x_22_1@2x.png" alt="" @click="handleDelKjdy(item.id)"/>
			  </div>
			  <div class="zbz-kjdy-empty" v-if="kjdyList.length === 0">{{$t('all.zanwushuju')}}</div>
			</div>
			<!-- 新增弹框 -->
			<div class="zbz-kjdy-add-modal" v-if="showKjdyAdd">
			  <div class="zbz-kjdy-add-title">{{$t('all.xinzengkuaijieduanyu')}}</div>
			  <input class="zbz-kjdy-add-input" v-model="newKjdyContent" type="text" :placeholder="$t('all.qingshuru')"/>
			  <div class="zbz-kjdy-add-btns">
				<div class="zbz-kjdy-add-cancel" @click="showKjdyAdd = false">{{$t('all.quxiao')}}</div>
				<div class="zbz-kjdy-add-confirm" @click="handleAddKjdy">{{$t('all.tijiao')}}</div>
			  </div>
			</div>
		  </div>
		  <!-- 公告弹框 -->
		  <div class="zbz-notice-modal" v-if="showNotice">
			<div class="zbz-notice-mask" @click="handleCloseNotice"></div>
			<div class="zbz-notice-content">
			  <div class="zbz-notice-header">
				<span class="zbz-notice-title">{{$t('all.gonggao')}}</span>
				<img class="zbz-notice-close" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" @click="handleCloseNotice"/>
			  </div>
			  <div class="zbz-notice-body">
				<template v-if="isHost || noticeText">
				  <textarea 
					v-model="noticeText" 
					:placeholder="$t('all.qingshuru')" 
					:disabled="!isHost"
					:class="{ 'zbz-notice-textarea-disabled': !isHost }"
				  ></textarea>
				</template>
				<div v-else class="zbz-notice-empty">{{$t('all.zanwugonggao')}}</div>
			  </div>
			  <div class="zbz-notice-footer" v-if="isHost">
				<div class="zbz-notice-btn" @click="handleUpdateNotice">{{$t('all.tijiao')}}</div>
			  </div>
			</div>
		  </div>
		</div>
	</div>

	<!-- 打赏弹框 -->
	<div class="zbz-reward-overlay" v-if="showRewardModal" @click="showRewardModal = false"></div>
	<div class="zbz-reward-modal" v-if="showRewardModal" @click.stop>
		<div class="zbz-reward-title">{{$t('all.xuanzedashangbizhong')}}</div>
		<div class="zbz-reward-coins">
			<div 
				:class="rewardCoinIndex === index ? 'zbz-reward-coin-active' : 'zbz-reward-coin'" 
				v-for="(item, index) in walletList" 
				:key="index"
				@click="rewardCoinIndex = index"
			>
				<img class="zbz-reward-coin-icon" :src="item.currencyLogo" alt="" />
				<div class="zbz-reward-coin-content">
					<span class="zbz-reward-coin-name">{{item.unitText}}</span>
					<span class="zbz-reward-coin-balance">{{$t('all.yue')}} {{item.sumAvailableAmount}}</span>
				</div>
				
			</div>
		</div>
		<div class="zbz-reward-section">{{$t('all.dashangjine')}}</div>
		<div class="zbz-reward-amounts">
			<div 
				:class="rewardAmountIndex === index ? 'zbz-reward-amount-active' : 'zbz-reward-amount-a'" 
				v-for="(item, index) in giveAmountConfig.amountList" 
				:key="index"
				@click="rewardAmountIndex = index; customAmount = ''"
			>{{item}} {{walletList[rewardCoinIndex].unitText}}</div>
			<div 
				:class="customAmount ? 'zbz-reward-amount-active' : 'zbz-reward-amount-a'"
				@click="rewardAmountIndex = -1"
			>{{$t('all.zidingyi')}}</div>
		</div>
		<div class="zbz-reward-custom-input" v-if="rewardAmountIndex === -1">
			<input 
				class="zbz-reward-input" 
				v-model="customAmount" 
				type="number" 
				step="0.01"
				:placeholder="$t('all.qingshuru')" 
				@input="handleCustomAmountInput"
			/>
			<span class="zbz-reward-input-unit">{{walletList[rewardCoinIndex].unitText}}</span>
		</div>
		<div class="zbz-reward-total">
			<span class="zbz-reward-total-label">{{$t('all.dashangjine')}}</span>
			<span class="zbz-reward-total-value">{{rewardAmountIndex >= 0 ? rewardAmounts[rewardAmountIndex] : customAmount}} {{walletList[rewardCoinIndex].unitText}}</span>
		</div>
		<div class="zbz-reward-btn" @click="handleConfirmReward">{{$t('all.querendashang')}}</div>
	</div>

	<!-- 商品详情弹框 -->
	<div class="zbz-goods-detail-overlay" v-if="showGoodsDetail" @click="showGoodsDetail = false"></div>
	<div class="zbz-goods-detail-modal" v-if="showGoodsDetail && selectedGoods" @click.stop>
		<div class="zbz-goods-detail-header">
			<span class="zbz-goods-detail-header-title">{{$t('all.shangpinxiangqing')}}</span>
			<img class="zbz-goods-detail-close" @click="showGoodsDetail = false" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" />
		</div>
		<div class="zbz-goods-detail-body">
			<!-- 商品图片轮播 -->
			<div class="zbz-goods-detail-carousel">
				<div class="zbz-goods-detail-carousel-inner" :style="{ transform: 'translateX(-' + detailCarouselIndex * 100 + '%)' }">
					<img v-for="(img, index) in selectedGoodsImages" :key="index" class="zbz-goods-detail-carousel-img" :src="img" alt="" />
				</div>
				<div class="zbz-goods-detail-carousel-dots" v-if="selectedGoodsImages.length > 1">
					<span 
						v-for="(img, index) in selectedGoodsImages" 
						:key="index" 
						:class="detailCarouselIndex === index ? 'zbz-goods-detail-dot-active' : 'zbz-goods-detail-dot'"
						@click="detailCarouselIndex = index"
					></span>
				</div>
			</div>
			<!-- 价格信息 -->
			<div class="zbz-goods-detail-price-row">
				<div class="zbz-goods-detail-price-left">
					<span class="zbz-goods-detail-price-label">USDN</span>
					<span class="zbz-goods-detail-price-value">{{selectedGoods.price}}</span>
				</div>
				<span class="zbz-goods-detail-stock">{{$t('all.shangchengkucun')}}：{{selectedGoods.totalStock}}</span>
			</div>
			<!-- 商品名称 -->
			<div class="zbz-goods-detail-name">{{selectedGoods.goodsName}}</div>
			<!-- 商品详情分割线 -->
			<div class="zbz-goods-detail-divider">
				<span class="zbz-goods-detail-divider-line"></span>
				<span class="zbz-goods-detail-divider-text">{{$t('all.shangpinxiangqing')}}</span>
				<span class="zbz-goods-detail-divider-line"></span>
			</div>
			<!-- 商品详情图片 -->
			<div class="zbz-goods-detail-images">
				<img v-for="(img, index) in selectedGoodsImages" :key="index" class="zbz-goods-detail-desc-img" :src="img" alt="" />
			</div>
		</div>
		<!-- 底部立即加购按钮 -->
		<div class="zbz-goods-detail-footer">
			<div class="zbz-goods-detail-buy-btn" @click="handleDetailBuy">{{$t('all.lijijiagou')}}</div>
		</div>
	</div>

	<!-- 商品购买弹框（选规格） -->
	<div class="zbz-goods-overlay" v-if="showGoodsModal" @click="showGoodsModal = false"></div>
	<div class="zbz-goods-modal" v-if="showGoodsModal" @click.stop>
		<div class="zbz-goods-modal-header">
			<span class="zbz-goods-modal-header-span">{{$t('all.goumaishangpin')}}</span>
			<img class="zbz-goods-modal-close" @click="showGoodsModal = false" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" />
		</div>
		<div class="zbz-goods-modal-body">
			<div class="zbz-goods-modal-info">
				<img class="zbz-goods-modal-img" :src="selectedGoods.mediasList[0].uri" alt="" />
				<div class="zbz-goods-modal-detail">
					<span class="zbz-goods-modal-name">{{selectedGoods.goodsName}}</span>
					<span class="zbz-goods-modal-selected">{{$t('all.yixuan')}}：{{selectedSpec.name}}</span>
					<span class="zbz-goods-modal-price">USDN {{selectedSpec.price}}</span>
					<div class="zbz-goods-modal-info-kucun">
						<span class="zbz-goods-modal-info-kucun-span">{{$t('all.kucun')}}：{{selectedSpec.inventory}}</span>
						<div class="zbz-goods-modal-count">
						    <img class="zbz-goods-modal-count-btn" @click="decreaseBuyCount" src="../../../assets/image/shuliang_jian@2x.png" alt="" />
							<span class="zbz-goods-modal-count-num">{{buyCount}}</span>
							<img class="zbz-goods-modal-count-btn" @click="increaseBuyCount" src="../../../assets/image/shuliang_jia@2x.png" alt="" />
						</div>
					</div>
					
				</div>
			</div>
			<div class="zbz-goods-modal-section">{{$t('all.xuanzeguiige')}}</div>
			<div class="zbz-goods-modal-specs"> 
				<div 
					:class="selectedSpec.dbSpecificationId === item.dbSpecificationId ? 'zbz-goods-modal-spec-active' : 'zbz-goods-modal-spec'"
					v-for="item in selectedGoods.specificationList" 
					:key="item.dbSpecificationId"
					@click="selectSpec(item)"
				>
					<!-- <img class="zbz-goods-modal-spec-img" :src="item.specImage" alt="" /> -->
					<span class="zbz-goods-modal-spec-name">{{item.name}}</span>
					<span class="zbz-goods-modal-spec-price">USDN{{item.price}}</span>
				</div>
			</div>
			<div class="zbz-goods-modal-footer">
				<div class="zbz-goods-modal-add-btn" @click="handleAddToCart">{{$t('all.lijijiagou')}}</div>
			</div>
		</div>
		
	</div>
	
	<!-- 分享链接弹框 -->
	<div class="xtzb-invite-overlay" v-if="showShareLink" @click="showShareLink = false"></div>
	<div class="xtzb-share-modal" v-if="showShareLink" @click.stop>
	  <div class="xtzb-share-title">{{$t('all.fenxiangyaoqing')}}</div>
	  <div class="xtzb-share-qrcode">
	    <canvas ref="qrcodeCanvas"></canvas>
	  </div>
	  <div class="xtzb-share-item">
	    <span class="xtzb-share-item-label">{{$t('all.yaoqinglianjie')}}</span>
	    <span class="xtzb-share-item-value">{{data.shareUrl}}</span>
	  </div>
	  <div class="xtzb-share-subtitle">{{$t('all.fenxiangfangshi')}}</div>
	  <div class="xtzb-share-actions">
	    <div class="xtzb-share-action-btn xtzb-share-action-gradient" @click="handleCopyLink">{{$t('all.fuzhilianjie')}}</div>
	    <div class="xtzb-share-action-btn" @click="handleSaveQr">{{$t('all.baocunerweima')}}</div>
	  </div>
	</div>
  </div>
</template>

<script>
import { getChatRoomDetails, getLiveCommonExpressionsList, addLiveCommonExpressions, 
delLiveCommonExpressions, chatRoomSendMsg, getChatRoomOnlineUserCount, getChatRoomOnlineUserList, 
closeChatRoom, checkIsLogin, bannedToPostUser, kickOutChatRoom,getChatRoomUserDetails,
relieveBannedToPostUser, updNotice,quitChatRoom,getGoodsList,submitOrder,setGoodsExplain,getLiveIsExplainGoodsInfo } from "@/api/zhibo";
import { updateCameraStatus, updateMicrophoneStatus } from "@/api/zhubo";
import { getGiveAmountConfig,getUserWalletList,toGive } from "@/api/qianbao";
import tengxunyunzb from "../../../components/tengxunyunzb/tengxunyunzb.vue";
import tengxunyun from "../../../components/tengxunyun/tengxunyun.vue";
import xietongzhibo from "../../../components/xietongzhibo/xietongzhibo.vue";
import tengxunyunzhubo from "../../../components/tengxunyunzhubo/tengxunyunzhubo.vue";
import mainscreenplayer from "../../../components/mainscreenplayer/mainscreenplayer.vue";
import kong from "../../../components/kong/kong.vue";
import QRCode from 'qrcode';
export default {
  components: {
    tengxunyunzb,
    tengxunyun,
    xietongzhibo,
	tengxunyunzhubo,
	mainscreenplayer,
	kong
  },
  data() {
    return {
      soundOn: true,
      danmuOn: true,
      micOn: true,

      beautyOn: false,
      coLiveOn: true,
      showNotice: false,
      noticeText: '',
      lastNoticeText: '',
      volume: 30,
      isHost: false,
      onlineCount: 0,
      onlineUserList: [],
      liveStartTimestamp: Date.now(),
      liveTimeText: '00:00:00',
      liveTimer: null,
      chatContent: '',
      msgList: [{ title: this.$t('all.danmushuoming') }],
      kjdyList: [],
      showKjdyTags: true,
      showKjdyModal: false,
      showKjdyAdd: false,
      newKjdyContent: '',
      isDragging: false,
      dragStartX: 0,
      dragScrollLeft: 0,
      goodsList: null,
	  startKeyId:null,
      showRewardModal: false,
      rewardCoinIndex: 0,
      rewardAmountIndex: 0,
      rewardCoins: ['NB Chain', 'USDT', 'ETH'],
      rewardAmounts: [10, 50, 100, 200],
      customAmount: '',
      coliveList: [],
      data: null,
	  showModelFj:false,
	  sendUserId:null,
	  msgIndex:null,
	  showProductPopup: false,
	  productPopupData: null,
	  sendUserInfo:null,
	  showOnlineFj:false,
	  onlineIndex:-1,
	  onlineUserInfo:null,
	  rewardList: [],
	  rewardTimer: null,
	  giveAmountConfig:null,
	  walletList:null,
	  liveId: this.$route.query.liveId,
	  showGoodsModal: false,
	  showGoodsDetail: false,
	  detailCarouselIndex: 0,
	  showViewerLeft: false,
	  selectedGoods: null,
	  selectedSpec: null,
	  buyCount: 1,
	  showShareLink:false
    };
  },
  computed: {
    currentUserId() {
      return this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
    },
    selectedGoodsImages() {
      if (!this.selectedGoods || !this.selectedGoods.mediasList) return [];
      return this.selectedGoods.mediasList.map(item => item.uri);
    },
    backgroundStyle() {
      const bgUrl = this.data && this.data.chatRoomDetails && this.data.chatRoomDetails.backgroundUrl;
      if (bgUrl) {
        return {
          backgroundImage: `url(${bgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      }
      return {};
    },
    mainScreenUser() {
      if (!this.data || !this.data.helpLiveUserList) return null;
      return this.data.helpLiveUserList.find(item => item.isMainScreen === 1);
    },
    isSelfMainScreen() {
      if (!this.currentUserId || !this.mainScreenUser) return false;
      return this.mainScreenUser.userInfo && this.mainScreenUser.userInfo.userId === this.currentUserId;
    },
    isJoinedHelpLive() {
      if (!this.currentUserId || !this.data || !this.data.helpLiveUserList) return false;
      return this.data.helpLiveUserList.some(function(item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
    },
    viewerMicOn() {
      if (!this.currentUserId || !this.data || !this.data.helpLiveUserList) return true;
      var helpUser = this.data.helpLiveUserList.find(function(item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
      return helpUser ? helpUser.microphoneStatus === 1 : true;
    },
    viewerCameraOn() {
      if (!this.currentUserId || !this.data || !this.data.helpLiveUserList) return true;
      var helpUser = this.data.helpLiveUserList.find(function(item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
      return helpUser ? helpUser.cameraStatus === 1 : true;
    }
  },
  mounted() {
    this.getChatRoomDetails();
    this.getOnlineUserList();
    this.getLiveCommonExpressionsList();
    this.startLiveTimer();
    this.connectWebSocket();
	this.getGiveAmountConfig()
	this.getLiveIsExplainGoodsInfo()
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    if (this.liveTimer) clearInterval(this.liveTimer);
    if (this.rewardTimer) clearInterval(this.rewardTimer);
    this.$ws.close();
    document.removeEventListener('click', this.handleDocumentClick);
	this.quitChatRoom()
	this.cleanupMediaDevices()
  },
  beforeRouteLeave(to, from, next) {
    this.cleanupMediaDevices()
    next()
  },
  methods: {
	cleanupMediaDevices() {
	  if (this.$refs.txyzb && this.$refs.txyzb.livePusher) {
		try {
		  this.$refs.txyzb.livePusher.stopCamera();
		  this.$refs.txyzb.livePusher.stopMicrophone();
		  this.$refs.txyzb.livePusher.stopPush();
		  this.$refs.txyzb.livePusher.destroy();
		  this.$refs.txyzb.livePusher = null;
		} catch (e) {
		  console.warn('清理推流失败:', e);
		}
	  }
	  if (this.$refs.xietongzhibo && this.$refs.xietongzhibo.selfPusher) {
		try {
		  this.$refs.xietongzhibo.selfPusher.stopCamera();
		  this.$refs.xietongzhibo.selfPusher.stopMicrophone();
		  this.$refs.xietongzhibo.selfPusher.stopPush();
		  this.$refs.xietongzhibo.selfPusher.destroy();
		  this.$refs.xietongzhibo.selfPusher = null;
		} catch (e) {
		  console.warn('清理协同推流失败:', e);
		}
	  }
	  if (this.$refs.xietongzhibo) {
		this.$refs.xietongzhibo.destroyPlayers()
	  }
	  navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then(stream => {
		stream.getTracks().forEach(track => track.stop());
	  }).catch(() => {});
	  console.log('媒体设备已清理');
	},
	async quitChatRoom(){
	  console.log('我退出了直播间')
	  if (this.liveId) {
		const res = await quitChatRoom({liveId: this.liveId})
	  }
	},
    async getChatRoomDetails() {
      try {
        const res = await getChatRoomDetails({ liveId: this.$route.query.liveId });
        this.data = res.data;
        const newNoticeText = res.data.chatRoomDetails.noticeText || '';
        if (newNoticeText && newNoticeText !== this.lastNoticeText) {
          this.msgList.push({ 
            type: -1, 
            title: newNoticeText 
          });
          this.lastNoticeText = newNoticeText;
        }
        this.noticeText = newNoticeText;
        // this.onlineCount = res.data.chatRoomDetails.onlineUserCount || 0;
        // 判断当前用户是否是主播
        if (this.$store.state.userId && res.data.chatRoomDetails.hostUserInfo && res.data.chatRoomDetails.hostUserInfo.userId == JSON.parse(this.$store.state.userId)) {
          this.isHost = true;
        } else {
          this.isHost = false;
        }
		this.startKeyId = res.data.chatRoomDetails.startKeyId
		this.getGoodsList()
      } catch (error) {
        console.error('获取直播间详情失败:', error);
      }
    },
	async getGoodsList(){
	  const res = await getGoodsList({liveId:this.liveId,startKeyId:this.startKeyId})
	  this.goodsList = res.data.map(item => {
		const totalStock = (item.specificationList || []).reduce((sum, spec) => {
		  return sum + (parseInt(spec.inventory) || 0)
		}, 0)
		return { ...item, totalStock }
	  })
	  this.goodsList.forEach(v=>{
	  	const priceArr = v.specificationList.map(item => item.price);
	  	if (v.specificationList.length === 1) {
	  	    v.price = this.formatPrice(priceArr[0]);
	  	} else {
	  	    const minPrice = Math.min(...priceArr);
	  	    const maxPrice = Math.max(...priceArr);
	  	    if (minPrice === maxPrice) {
	  	        v.price = this.formatPrice(minPrice);
	  	    } else {
	  	        v.price = `${this.formatPrice(minPrice)}-${this.formatPrice(maxPrice)}`;
	  	    }
	  	}
		v.specificationList.forEach(a=>{
			a.price = this.formatPrice(a.price)
		})
	  })
	  console.log(this.goodsList)
	},
    handleBuyGoods(item) {
      this.selectedGoods = item;
      this.selectedSpec = item.specificationList[0];
      this.buyCount = 1;
      this.showGoodsModal = true;
    },
    handleDetailBuy() {
      this.showGoodsDetail = false;
      setTimeout(v=>{
		  this.showGoodsModal = true;
	  },100)
    },
    selectSpec(spec) {
      this.selectedSpec = spec;
    },
    decreaseBuyCount() {
      if (this.buyCount > 1) {
        this.buyCount--;
      }
    },
    increaseBuyCount() {
      const maxStock = this.selectedSpec.stock || this.selectedSpec.inventory || 999;
      if (this.buyCount < maxStock) {
        this.buyCount++;
      }
    },
    async handleAddToCart() {
	  if(!this.selectedSpec) return
	  const res = await submitOrder({dbSpecificationId:this.selectedSpec.dbSpecificationId,num:this.buyCount})
      this.$message.success(res.msg);
      this.showGoodsModal = false;
    },
    
    
    handleShowNotice() {
      this.showNotice = true;
    },
    handleCloseNotice() {
      this.showNotice = false;
    },
    async handleUpdateNotice() {
      try {
        await updNotice({
          noticeText: this.noticeText,
          liveId: this.$route.query.liveId
        });
        this.$message.success(this.$t('all.caozuochenggong'));
        this.handleCloseNotice();
      } catch (error) {
        console.error('更新公告失败:', error);
      }
    },
    async getOnlineUserList() {
      const res = await getChatRoomOnlineUserList({ liveId: this.$route.query.liveId, page: 1, size: 100 });
      this.onlineUserList = res.rows || [];
      this.onlineCount = res.total
    },
    async getLiveCommonExpressionsList() {
      try {
        const res = await getLiveCommonExpressionsList({ liveId: this.$route.query.liveId });
        this.kjdyList = res.data || [];
      } catch (error) {
        console.error('获取快捷短语失败:', error);
      }
    },
    connectWebSocket() {
      const liveId = this.$route.query.liveId;
      const userId = this.$store.state.userId;
      this.$ws.connect(liveId, userId);
      this.$ws.onMessage = (res) => {
        if (!res) return;
        const data = JSON.parse(res);
        if (data.data && data.data.pushType == 1) {
          const msg = data.data.details;
          msg.title = this.$t('all.jinrulezhibojian');
          msg.type = 1;
          this.msgList.push(msg);
          //this.onlineCount++;
          this.getOnlineUserList();
          this.scrollToBottom();
        }
        if (data.data && data.data.pushType == 2) {
          //this.onlineCount = Math.max(0, this.onlineCount - 1);
          this.getOnlineUserList();
		  if (this.$refs.xietongzhibo) {
		    this.$refs.xietongzhibo.getChatRoomDetails();
		  }
        }
        if (data.data && data.data.pushType == 3) {
          const msg = data.data.details;
          msg.title = data.data.content;
          msg.type = 3;
          this.msgList.push(msg);
          this.scrollToBottom();
        }
        if (data.data && data.data.pushType == 15) {
          this.msgList.push({ type: -1, title: data.data.content });
          this.scrollToBottom();
        }
        if (data.data && data.data.pushType == 16) {
          const msg = data.data.details;
          msg.type = 12;
          this.msgList.push(msg);
          this.scrollToBottom();
        }
        if (data.data && data.data.pushType == 24) {
          this.getLiveCommonExpressionsList();
		  this.getChatRoomDetails()
		  if (this.$refs.xietongzhibo) {
		    this.$refs.xietongzhibo.getChatRoomDetails();
		  }
        }
		if (data.data && data.data.pushType == 31) {
		  this.$refs.xietongzhibo.getChatRoomDetails()
		}
		if (data.data && data.data.pushType == 32) {
		  console.log(data.data)
		  this.rewardList.push(data.data.details);
		  if (this.rewardList.length > 20) {
			this.rewardList.shift();
		  }
		  this.scrollRewardToBottom();
		}
		if (data.data && data.data.pushType == 33) {
		  this.getGoodsList()
		  this.getLiveIsExplainGoodsInfo()
		}
      };
    },
    startLiveTimer() {
      this.liveTimer = setInterval(() => {
        const elapsed = Math.floor((Date.now() - this.liveStartTimestamp) / 1000);
        const h = String(Math.floor(elapsed / 3600)).padStart(2, '0');
        const m = String(Math.floor((elapsed % 3600) / 60)).padStart(2, '0');
        const s = String(elapsed % 60).padStart(2, '0');
        this.liveTimeText = `${h}:${m}:${s}`;
      }, 1000);
    },
    scrollRewardToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.rewardContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    toggleSound() { this.soundOn = !this.soundOn; },
    toggleDanmu() { this.danmuOn = !this.danmuOn; },
    async toggleViewerMic() {
      if (!this.data || !this.data.helpLiveUserList) return;
      var helpUser = this.data.helpLiveUserList.find(function(item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
      if (!helpUser) return;
      var newStatus = helpUser.microphoneStatus === 1 ? 0 : 1;
      const res = await updateMicrophoneStatus({ helpId: helpUser.helpId, status: newStatus });
	  this.$message.success(res.msg);
      this.getChatRoomDetails();
      if (this.$refs.xietongzhibo) {
        this.$refs.xietongzhibo.getChatRoomDetails();
      }
    },
    async toggleViewerCamera() {
      if (!this.data || !this.data.helpLiveUserList) return;
      var helpUser = this.data.helpLiveUserList.find(function(item) {
        return item.userInfo && item.userInfo.userId === this.currentUserId;
      }.bind(this));
      if (!helpUser) return;
      var newStatus = helpUser.cameraStatus === 1 ? 0 : 1;
      const res = await updateCameraStatus({ helpId: helpUser.helpId, status: newStatus });
	  this.$message.success(res.msg);
      this.getChatRoomDetails();
      if (this.$refs.xietongzhibo) {
        this.$refs.xietongzhibo.getChatRoomDetails();
      }
    },
    handleColiveSelect(index) {
      console.log('协同直播切换:', index);
    },
    async handleJoinSuccess() {
	  console.log('112233')
      await this.getChatRoomDetails();
      this.viewerMicOn = true
	  console.log(this.viewerMicOn,'this.viewerMicOn')
    },
    handleViewerSound() {
      if (this.$refs.txy) {
        this.soundOn = !this.soundOn;
        this.$refs.txy.updateMuted(!this.soundOn);
      }
    },
	async getGiveAmountConfig() {
	  const res = await getGiveAmountConfig()
	  this.giveAmountConfig = res.data
	},
    async handleReward() {
	  const res = await getUserWalletList()
	  this.walletList = res.data.walletList
      this.showRewardModal = true;
    },
    handleCustomAmountInput(e) {
      let val = e.target.value;
      val = val.replace(/[^\d.]/g, '');
      val = val.replace(/^\./, '');
      val = val.replace(/\.{2,}/g, '.');
      val = val.replace(/(\.\d{2})\d*/, '$1');
      this.customAmount = val;
    },
    async handleConfirmReward() {
      const amount = this.rewardAmountIndex >= 0 
        ? this.giveAmountConfig.amountList[this.rewardAmountIndex] 
        : this.customAmount;
      
      if (!amount || parseFloat(amount) <= 0) {
        this.$message.error(this.$t('all.qingshuruzhengque'));
        return;
      }
	  const res = await toGive({
		  amount:amount,
		  currencyId:this.walletList[this.rewardCoinIndex].currencyId,
		  liveId:this.$route.query.liveId
	  })
      this.$message.success(res.msg);
      this.showRewardModal = false;
    },
    toggleMic() {
      this.micOn = !this.micOn;
      if (this.micOn) {
        this.volume = 100;
      } else {
        this.volume = 0;
      }
      this.handleVolumeChange();
    },
    handleShare() {
	  this.showShareLink = true
	  this.$nextTick(() => {
	    const canvas = this.$refs.qrcodeCanvas;
	    if (canvas) {
	  		QRCode.toCanvas(canvas, this.data.shareUrl, {
	  			width: 160,
	  			margin: 2,
	  			color: {
	  				dark: '#000000',
	  				light: '#ffffff'
	  			}
	  		}, (error) => {
	  			if (error) {
	  				console.error(error);
	  			}
	  		});
	    }
	  });
    },
	handleShowGoods() {
	  this.showViewerLeft = !this.showViewerLeft;
	},
	handleCopyLink() {
	  navigator.clipboard.writeText(this.data.shareUrl);
	  this.$message.success(this.$t('all.fuzhichenggong'));
	},
	handleSaveQr() {
	  const canvas = this.$refs.qrcodeCanvas;
	  if (!canvas) {
	    this.$message.info(this.$t('all.qrcodenotexist'));
	    return;
	  }
	  const link = document.createElement('a');
	  link.download = 'qrcode.png';
	  link.href = canvas.toDataURL('image/png');
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	  this.$message.success(this.$t('all.qrcodesaved'));
	},
    handleVolumeChange() {
      const vol = Number(this.volume);
      this.micOn = vol > 0;
      if (this.$refs.txyzb) {
        this.$refs.txyzb.setVolume(vol);
      }
    },
    setVolume(val) {
      this.volume = val;
      this.micOn = val > 0;
      if (this.$refs.txyzb) {
        this.$refs.txyzb.setVolume(val);
      }
    },
    decreaseStock(item) { if (item.liveStock > 0) item.liveStock--; },
    increaseStock(item) { item.liveStock++; },
    async handleSend() {
      const content = this.chatContent.trim();
      if (!content) return;
      try {
        await chatRoomSendMsg({ liveId: this.$route.query.liveId, content });
        this.chatContent = '';
      } catch (error) {
        console.error('发送消息失败:', error);
      }
    },
    async handleSendKjdy(content) {
      try {
        await chatRoomSendMsg({ liveId: this.$route.query.liveId, content });
      } catch (error) {
        console.error('发送快捷短语失败:', error);
      }
    },
    async handleAddKjdy() {
      if (!this.newKjdyContent.trim()) return;
      try {
        await addLiveCommonExpressions({ content: this.newKjdyContent, liveId: this.$route.query.liveId });
        this.newKjdyContent = '';
        this.showKjdyAdd = false;
        this.getLiveCommonExpressionsList();
      } catch (error) {
        console.error('添加快捷短语失败:', error);
      }
    },
    async handleDelKjdy(id) {
      try {
        await delLiveCommonExpressions({ id, liveId: this.$route.query.liveId });
        this.getLiveCommonExpressionsList();
      } catch (error) {
        console.error('删除快捷短语失败:', error);
      }
    },
    async handleEndLive() {
      try {
        await closeChatRoom({ liveId: this.$route.query.liveId });
        this.$message.success(this.$t('all.caozuochenggong'));
        this.$router.go(-1);
      } catch (error) {
        console.error('结束直播失败:', error);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer;
        if (container) container.scrollTop = container.scrollHeight;
      });
    },
    autoResize() {
      const el = this.$refs.chatInput;
      if (el) {
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 80) + 'px';
      }
    },
    startDragScroll(e) {
      this.isDragging = true;
      this.dragStartX = e.pageX - this.$refs.quickTags.offsetLeft;
      this.dragScrollLeft = this.$refs.quickTags.scrollLeft;
    },
    doDragScroll(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.quickTags.offsetLeft;
      const walk = (x - this.dragStartX) * 1.5;
      this.$refs.quickTags.scrollLeft = this.dragScrollLeft - walk;
    },
    stopDragScroll() {
      this.isDragging = false;
    },
	handleShowModelFj(data,index){
		if(!data.sendUserId) return;
		if(this.showModelFj && this.sendUserId === data.sendUserId){
			this.showModelFj = false;
			this.sendUserId = null;
		}else{
			this.msgIndex = index;
			this.getChatRoomUserDetails(data.sendUserId)
		}
	},
	async getChatRoomUserDetails(userId){
		const res = await getChatRoomUserDetails({
			liveId: this.$route.query.liveId,
			toUserId: userId
		})
		this.sendUserInfo = res.data.subjoinParameter.chatRoomUserCurrentRecordsInfo
		console.log(this.sendUserInfo)
		this.sendUserId = userId;
		this.showModelFj = true;
	},
	handleDocumentClick(e){
		if(e.target.closest('.zbz-chat-item-fj')) return;
		if(e.target.closest('.zbz-chat-content-wrapper')) return;
		this.closeModelFj();
		this.closeOnlineFj();
	},
	closeModelFj(){
		this.showModelFj = false;
		this.sendUserId = null;
		this.msgIndex = -1;
	},
	closeOnlineFj(){
		this.showOnlineFj = false;
		this.onlineIndex = -1;
	},
	handleShowOnlineFj(item,index){
		if(!item.userId) return;
		if(this.showOnlineFj && this.onlineIndex === index){
			this.showOnlineFj = false;
			this.onlineIndex = -1;
		}else{
			this.onlineIndex = index;
			this.getOnlineUserDetails(item.userId);
		}
	},
	async getOnlineUserDetails(userId){
		const res = await getChatRoomUserDetails({
			liveId: this.$route.query.liveId,
			toUserId: userId
		})
		this.onlineUserInfo = res.data.subjoinParameter.chatRoomUserCurrentRecordsInfo;
		this.showOnlineFj = true;
	},
	async handleBannedUserById(){
		if(!this.onlineUserInfo) return;
		try{
			let res;
			if(this.onlineUserInfo.isBannedToPost == 0){
				res = await bannedToPostUser({
					liveId: this.$route.query.liveId,
					toUserId: this.onlineUserInfo.userId
				});
			}else{
				res = await relieveBannedToPostUser({
					liveId: this.$route.query.liveId,
					toUserId: this.onlineUserInfo.userId
				});
			}
			this.$message.success(res.msg);
			this.closeOnlineFj();
		}catch(error){
			console.error('禁言失败:', error);
		}
	},
	async handleKickUserById(userId){
		try{
			await kickOutChatRoom({
				liveId: this.$route.query.liveId,
				toUserId: userId,
				kickOutMinutes: 1
			});
			this.$message.success(this.$t('all.caozuochenggong'));
			this.closeOnlineFj();
			this.getOnlineUserList();
		}catch(error){
			console.error('踢出失败:', error);
		}
	},
	async handleBannedUser(msg){
		if(!msg.sendUserId) return;
		let res
		if(this.sendUserInfo.isBannedToPost ==0){
			res = await bannedToPostUser({
				liveId: this.$route.query.liveId,
				toUserId: msg.sendUserId
			});
		}
		if(this.sendUserInfo.isBannedToPost ==1){
			res = await relieveBannedToPostUser({
				liveId: this.$route.query.liveId,
				toUserId: msg.sendUserId
			});
		}
		this.$message.success(res.msg);
		this.closeModelFj();
	},
	async handleKickUser(msg){
		if(!msg.sendUserId) return;
		const res =  await kickOutChatRoom({
			liveId: this.$route.query.liveId,
			toUserId: msg.sendUserId,
			kickOutMinutes:1
		});
		this.$message.success(res.msg);
		this.closeModelFj();
		this.getOnlineUserList();
	},
	//打开协同助播
	handleCreateHelpLive(){
	  this.$refs.xietongzhibo.showModel()
	},
	//观众：加入或退出协同直播
	async handleHelpLiveToggle(){
	  if(this.data.isOpenHelp != 1){
		this.$message.warning(this.$t('all.zanweikaiqi'));
		return;
	  }
	  if(this.isJoinedHelpLive){
		// 已加入，执行退出
		if (this.$refs.xietongzhibo) {
			await this.$refs.xietongzhibo.handleExitHelp()
			// 退出后刷新父组件数据以更新按钮状态
			await this.getChatRoomDetails()
		}
	  }else{
		// 未加入，执行加入
		if (this.$refs.xietongzhibo) {
			this.$refs.xietongzhibo.handleJoinLive()
		}
	  }
	},
	handleExitHelpLive(){
	  if (this.$refs.xietongzhibo) {
		this.$refs.xietongzhibo.handleExitHelp()
	  }
	},
	//讲解商品
	async setGoodsExplain(data){
	  const res = await setGoodsExplain({liveId:this.liveId,dbGoodsId:data.dbGoodsId})
	  this.$message.success(res.msg);
	},
	//讲解中的商品信息
	async getLiveIsExplainGoodsInfo(){
	  const res = await getLiveIsExplainGoodsInfo({liveId:this.liveId})
	  if(!res.data) return
	  this.productPopupData = res.data
	  const priceArr = this.productPopupData.specificationList.map(item => item.price);
	  if (this.productPopupData.specificationList.length === 1) {
	      this.productPopupData.price = this.formatPrice(priceArr[0]);
	  } else {
	      const minPrice = Math.min(...priceArr);
	      const maxPrice = Math.max(...priceArr);
	      if (minPrice === maxPrice) {
	          this.productPopupData.price = this.formatPrice(minPrice);
	      } else {
	          this.productPopupData.price = `${this.formatPrice(minPrice)}-${this.formatPrice(maxPrice)}`;
	      }
	  }
	  this.productPopupData.specificationList.forEach(v=>{
		v.price = this.formatPrice(v.price)
	  })
	  this.showProductPopup = true;
	},
	hideProduct() {
	  this.showProductPopup = false;
	},
	handleProductClick() {
	  this.selectedGoods = this.productPopupData;
	  this.selectedSpec = this.productPopupData.specificationList[0];
	  this.buyCount = 1;
	  this.detailCarouselIndex = 0;
	  this.showGoodsDetail = true;
	},
	handleViewGoodsDetail(item) {
	  this.selectedGoods = item;
	  this.selectedSpec = item.specificationList[0];
	  this.buyCount = 1;
	  this.detailCarouselIndex = 0;
	  this.showGoodsDetail = true;
	},
	//格式化价格：去掉小数点后多余的0
	formatPrice(price) {
		if (price === undefined || price === null) return '';
		const num = parseFloat(price);
		if (isNaN(num)) return price;
		return num.toString();
	},
  }
};
</script>

<style scoped lang="scss">
@import "./zhibozhong.css";
</style>



// WEBPACK FOOTER //
// zhibozhong.vue?52c3f2f0